/**
 * PDP Info-Tabs — simple tab nav + panel switching for the Jolie.com-style
 * tabbed content section. No slide/drawer mechanics needed here (unlike
 * the FAQ drawer) — panels are inline, so switching is an instant
 * show/hide with a soft fade handled in CSS.
 */
(function () {
  function initPdpTabs(root) {
    if (!root || root.dataset.pdpTabsInit === 'true') return;
    root.dataset.pdpTabsInit = 'true';

    var triggers = root.querySelectorAll('[data-pdp-tab-trigger]');
    var panels = root.querySelectorAll('[data-pdp-tab-panel]');

    function activate(id) {
      triggers.forEach(function (t) {
        var isActive = t.getAttribute('data-pdp-tab-trigger') === id;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-pdp-tab-panel') === id);
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activate(trigger.getAttribute('data-pdp-tab-trigger'));
      });
    });

    root.querySelectorAll('[data-pdp-carousel]').forEach(initPdpCarousel);
  }

  /**
   * Auto-advancing image carousel for the "Mikronährstoffe" tab's comparison
   * images — same crossfade + dots + autoplay pattern used on the homepage
   * Problem/Lösung section, swapped in here instead of a static 2x2 grid
   * (which read as cluttered on desktop and confusing side-by-side on mobile).
   */
  function initPdpCarousel(root) {
    if (!root || root.dataset.pdpCarouselInit === 'true') return;
    root.dataset.pdpCarouselInit = 'true';

    var slides = root.querySelectorAll('[data-pdp-carousel-slide]');
    var dots = root.querySelectorAll('[data-pdp-carousel-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var timer;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(function () {
        show(current + 1);
      }, 4000);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-pdp-carousel-dot'), 10));
        startAutoplay();
      });
    });

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-pdp-tabs]').forEach(initPdpTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector && e.target.querySelector('[data-pdp-tabs]');
    if (section) initPdpTabs(section);
  });
})();